import { render, staticRenderFns } from "./OutboundCallCampaign.vue?vue&type=template&id=edef423c&scoped=true&"
import script from "./OutboundCallCampaign.vue?vue&type=script&lang=js&"
export * from "./OutboundCallCampaign.vue?vue&type=script&lang=js&"
import style0 from "./OutboundCallCampaign.vue?vue&type=style&index=0&id=edef423c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edef423c",
  null
  
)

export default component.exports